import handleCollapsedMenu from "./handle-collapsed-menu";

function handleWebsiteBanners() {
  //check with imports
  if (
    sessionStorage.getItem("showBanner") === "false" &&
    sessionStorage.getItem("showBanner")
  ) {
    $(".banner-top-page").addClass("d-none");
  }

  const topBannerHeight = $(".banner-top-page").length
    ? $(".banner-top-page").innerHeight()
    : 0;

  const topBarHeight = $(".js-topbar").length
    ? $(".js-topbar").innerHeight()
    : 0;

  document.documentElement.style.setProperty(
    "--top-banner-height",
    topBannerHeight + topBarHeight + "px"
  );

  $(".banner-top-page").on("close.bs.alert", () => {
    sessionStorage.setItem("showBanner", "false");
    $(".is-banner").removeClass("is-banner");
  });

  $(".banner-top-page").on("closed.bs.alert", () => {
    handleCollapsedMenu();
  });
}

export default handleWebsiteBanners;
